export default __webpack_public_path__ + "static/media/004-credit-card.9d91e6f9.png";